// ============================================================================
// FindMyFlight — client-side award engine (mock layer)
// Real airports + real airlines + points computed from real published
// distance-based award charts. Live seat inventory is simulated deterministically.
// ============================================================================
import AIRPORTS_DB from "./airports.json";
import SEO_CONTENT from "./seo_content.json";

// ---------------------------------------------------------------------------
// Airports (real IATA codes, cities, countries, regions, coordinates)
// ---------------------------------------------------------------------------
export const AIRPORTS = [
  { code: "JFK", city: "New York City", country: "United States", region: "North America", lat: 40.6413, lon: -73.7781 },
  { code: "EWR", city: "Newark", country: "United States", region: "North America", lat: 40.6895, lon: -74.1745 },
  { code: "LGA", city: "New York City", country: "United States", region: "North America", lat: 40.7769, lon: -73.874 },
  { code: "LAX", city: "Los Angeles", country: "United States", region: "North America", lat: 33.9416, lon: -118.4085 },
  { code: "SFO", city: "San Francisco", country: "United States", region: "North America", lat: 37.6213, lon: -122.379 },
  { code: "ORD", city: "Chicago", country: "United States", region: "North America", lat: 41.9742, lon: -87.9073 },
  { code: "DFW", city: "Dallas", country: "United States", region: "North America", lat: 32.8998, lon: -97.0403 },
  { code: "MIA", city: "Miami", country: "United States", region: "North America", lat: 25.7959, lon: -80.287 },
  { code: "SEA", city: "Seattle", country: "United States", region: "North America", lat: 47.4502, lon: -122.3088 },
  { code: "DEN", city: "Denver", country: "United States", region: "North America", lat: 39.8561, lon: -104.6737 },
  { code: "ATL", city: "Atlanta", country: "United States", region: "North America", lat: 33.6407, lon: -84.4277 },
  { code: "BOS", city: "Boston", country: "United States", region: "North America", lat: 42.3656, lon: -71.0096 },
  { code: "IAD", city: "Washington", country: "United States", region: "North America", lat: 38.9531, lon: -77.4565 },
  { code: "HNL", city: "Honolulu", country: "United States", region: "North America", lat: 21.3245, lon: -157.925 },
  { code: "YYZ", city: "Toronto", country: "Canada", region: "North America", lat: 43.6777, lon: -79.6248 },
  { code: "YVR", city: "Vancouver", country: "Canada", region: "North America", lat: 49.1967, lon: -123.1815 },
  { code: "MEX", city: "Mexico City", country: "Mexico", region: "North America", lat: 19.4363, lon: -99.0721 },
  { code: "LHR", city: "London", country: "United Kingdom", region: "Europe", lat: 51.47, lon: -0.4543 },
  { code: "CDG", city: "Paris", country: "France", region: "Europe", lat: 49.0097, lon: 2.5479 },
  { code: "FRA", city: "Frankfurt", country: "Germany", region: "Europe", lat: 50.0379, lon: 8.5622 },
  { code: "AMS", city: "Amsterdam", country: "Netherlands", region: "Europe", lat: 52.3105, lon: 4.7683 },
  { code: "MAD", city: "Madrid", country: "Spain", region: "Europe", lat: 40.4983, lon: -3.5676 },
  { code: "FCO", city: "Rome", country: "Italy", region: "Europe", lat: 41.8003, lon: 12.2389 },
  { code: "ZRH", city: "Zurich", country: "Switzerland", region: "Europe", lat: 47.4647, lon: 8.5492 },
  { code: "DUB", city: "Dublin", country: "Ireland", region: "Europe", lat: 53.4264, lon: -6.2499 },
  { code: "CPH", city: "Copenhagen", country: "Denmark", region: "Europe", lat: 55.6180, lon: 12.6560 },
  { code: "IST", city: "Istanbul", country: "Turkey", region: "Europe", lat: 41.2753, lon: 28.7519 },
  { code: "HND", city: "Tokyo", country: "Japan", region: "Asia", lat: 35.5494, lon: 139.7798 },
  { code: "NRT", city: "Tokyo", country: "Japan", region: "Asia", lat: 35.7719, lon: 140.3928 },
  { code: "ICN", city: "Seoul", country: "South Korea", region: "Asia", lat: 37.4602, lon: 126.4407 },
  { code: "HKG", city: "Hong Kong", country: "Hong Kong", region: "Asia", lat: 22.308, lon: 113.9185 },
  { code: "SIN", city: "Singapore", country: "Singapore", region: "Asia", lat: 1.3644, lon: 103.9915 },
  { code: "BKK", city: "Bangkok", country: "Thailand", region: "Asia", lat: 13.69, lon: 100.7501 },
  { code: "DEL", city: "New Delhi", country: "India", region: "Asia", lat: 28.5562, lon: 77.1 },
  { code: "BOM", city: "Mumbai", country: "India", region: "Asia", lat: 19.0896, lon: 72.8656 },
  { code: "PVG", city: "Shanghai", country: "China", region: "Asia", lat: 31.1443, lon: 121.8083 },
  { code: "MNL", city: "Manila", country: "Philippines", region: "Asia", lat: 14.5086, lon: 121.0197 },
  { code: "DXB", city: "Dubai", country: "United Arab Emirates", region: "Middle East", lat: 25.2532, lon: 55.3657 },
  { code: "DOH", city: "Doha", country: "Qatar", region: "Middle East", lat: 25.2731, lon: 51.6081 },
  { code: "SYD", city: "Sydney", country: "Australia", region: "Oceania", lat: -33.9399, lon: 151.1753 },
  { code: "MEL", city: "Melbourne", country: "Australia", region: "Oceania", lat: -37.669, lon: 144.841 },
  { code: "AKL", city: "Auckland", country: "New Zealand", region: "Oceania", lat: -37.0082, lon: 174.785 },
  { code: "GRU", city: "Sao Paulo", country: "Brazil", region: "South America", lat: -23.4356, lon: -46.4731 },
  { code: "EZE", city: "Buenos Aires", country: "Argentina", region: "South America", lat: -34.8222, lon: -58.5358 },
  { code: "BOG", city: "Bogota", country: "Colombia", region: "South America", lat: 4.7016, lon: -74.1469 },
  { code: "SCL", city: "Santiago", country: "Chile", region: "South America", lat: -33.3898, lon: -70.7944 },
  { code: "LIM", city: "Lima", country: "Peru", region: "South America", lat: -12.0219, lon: -77.1143 },
  { code: "JNB", city: "Johannesburg", country: "South Africa", region: "Africa", lat: -26.1392, lon: 28.246 },
  { code: "CPT", city: "Cape Town", country: "South Africa", region: "Africa", lat: -33.9715, lon: 18.6021 },
  { code: "CAI", city: "Cairo", country: "Egypt", region: "Africa", lat: 30.1219, lon: 31.4056 },
  { code: "NBO", city: "Nairobi", country: "Kenya", region: "Africa", lat: -1.3192, lon: 36.9278 },
];

export const REGIONS = [
  "North America", "Europe", "Asia", "Middle East", "Oceania", "South America", "Africa",
];

// Worldwide airport database (OurAirports open data: large + medium airports with scheduled service)
export const ALL_AIRPORTS = AIRPORTS_DB.map(([code, name, city, country, region, lat, lon, large, keywords]) => ({
  code, name, city, country, region, lat, lon, large: large === 1, keywords: keywords || "",
}));
const ALL_AIRPORT_MAP = Object.fromEntries(ALL_AIRPORTS.map((a) => [a.code, a]));

const norm = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const words = (s) => norm(s).split(/[^a-z0-9]+/);

// Relevance score for one airport against a normalized query (0 = no match)
function airportScore(a, q) {
  const city = norm(a.city);
  const kw = a.keywords ? words(a.keywords) : [];
  if (a.code.toLowerCase() === q) return 100;
  if (city === q) return 90;
  if (kw.includes(q)) return 85;
  if (city.startsWith(q)) return 80;
  if (words(a.name).some((w) => w.startsWith(q))) return 75;
  if (kw.some((w) => w.startsWith(q))) return 72;
  if (city.includes(q)) return 60;
  if (norm(a.name).includes(q)) return 50;
  if (q.length >= 4 && norm(a.country).startsWith(q)) return 30;
  return 0;
}

// Search by IATA code, city, airport name or country — ranked by relevance and airport size
export function searchAirports(query, limit = 8) {
  const q = norm(String(query || "").trim());
  if (!q) return [];
  return ALL_AIRPORTS
    .map((a) => ({ a, s: airportScore(a, q) }))
    .filter((x) => x.s > 0)
    .map((x) => ({ a: x.a, s: x.s + (x.a.large ? 5 : 0) }))
    .sort((x, y) => y.s - x.s || x.a.code.localeCompare(y.a.code))
    .slice(0, limit)
    .map((x) => x.a);
}

// ---------------------------------------------------------------------------
// Airlines & mileage programs (real). Logos via Google's public airline logos.
// ---------------------------------------------------------------------------
export const AIRLINES = {
  AA: { name: "American Airlines", program: "AAdvantage", alliance: "oneworld" },
  AS: { name: "Alaska Airlines", program: "Mileage Plan", alliance: "oneworld" },
  DL: { name: "Delta Air Lines", program: "SkyMiles", alliance: "SkyTeam" },
  UA: { name: "United Airlines", program: "MileagePlus", alliance: "Star Alliance" },
  AC: { name: "Air Canada", program: "Aeroplan", alliance: "Star Alliance" },
  BA: { name: "British Airways", program: "Executive Club", alliance: "oneworld" },
  QF: { name: "Qantas", program: "Frequent Flyer", alliance: "oneworld" },
  QR: { name: "Qatar Airways", program: "Privilege Club", alliance: "oneworld" },
  EK: { name: "Emirates", program: "Skywards", alliance: "None" },
  SQ: { name: "Singapore Airlines", program: "KrisFlyer", alliance: "Star Alliance" },
  NH: { name: "ANA", program: "Mileage Club", alliance: "Star Alliance" },
  LH: { name: "Lufthansa", program: "Miles & More", alliance: "Star Alliance" },
  AF: { name: "Air France", program: "Flying Blue", alliance: "SkyTeam" },
  VS: { name: "Virgin Atlantic", program: "Flying Club", alliance: "None" },
  TK: { name: "Turkish Airlines", program: "Miles&Smiles", alliance: "Star Alliance" },
  EI: { name: "Aer Lingus", program: "AerClub", alliance: "None" },
  SK: { name: "SAS", program: "EuroBonus", alliance: "Star Alliance" },
  AV: { name: "Avianca", program: "LifeMiles", alliance: "Star Alliance" },
  LA: { name: "LATAM", program: "LATAM Pass", alliance: "None" },
};

export const airlineLogo = (code) =>
  `https://www.gstatic.com/flights/airline_logos/70px/${code}.png`;

// Bank transfer partners (points transfer to programs)
export const TRANSFER_PARTNERS = {
  AMEX: { name: "Amex Membership Rewards", color: "#006fcf" },
  CHASE: { name: "Chase Ultimate Rewards", color: "#117aca" },
  CITI: { name: "Citi ThankYou", color: "#003b70" },
  CAPITALONE: { name: "Capital One", color: "#d03027" },
  BILT: { name: "Bilt Rewards", color: "#111111" },
};

const PROGRAM_PARTNERS = {
  AAdvantage: ["CITI", "BILT"],
  "Mileage Plan": ["BILT"],
  SkyMiles: ["AMEX"],
  MileagePlus: ["CHASE"],
  Aeroplan: ["AMEX", "CHASE", "CAPITALONE", "BILT"],
  "Executive Club": ["AMEX", "CHASE", "CAPITALONE"],
  "Frequent Flyer": ["AMEX", "CAPITALONE", "CITI"],
  "Privilege Club": ["CITI", "CAPITALONE"],
  Skywards: ["AMEX", "CHASE", "CAPITALONE"],
  KrisFlyer: ["AMEX", "CHASE", "CITI", "CAPITALONE"],
  "Miles & More": ["CAPITALONE"],
  "Flying Blue": ["AMEX", "CHASE", "CITI", "CAPITALONE", "BILT"],
  "Flying Club": ["AMEX", "CHASE", "CITI", "CAPITALONE"],
  "Miles&Smiles": ["BILT", "CITI", "CAPITALONE"],
  LifeMiles: ["AMEX", "CITI", "CAPITALONE"],
  "LATAM Pass": ["AMEX", "CAPITALONE"],
  "Mileage Club": ["AMEX"],
  EuroBonus: ["AMEX", "CHASE"],
  AerClub: ["AMEX", "CHASE", "CAPITALONE"],
};

export const CABINS = [
  { key: "economy", label: "Economy" },
  { key: "premium", label: "Premium" },
  { key: "business", label: "Business" },
  { key: "first", label: "First" },
];

// ---------------------------------------------------------------------------
// Geometry + real distance-based award chart
// ---------------------------------------------------------------------------
export function airportByCode(code) {
  return AIRPORTS.find((a) => a.code === code);
}

// Resolve ANY airport code — falls back to a synthesized airport with a
// deterministic plausible location so users can search any flight.
export function resolveAirport(code) {
  if (!code) return null;
  const c = String(code).trim().toUpperCase();
  const known = AIRPORTS.find((a) => a.code === c) || ALL_AIRPORT_MAP[c];
  if (known) return known;
  const h = strHash(c);
  const lat = ((h % 12000) / 100) - 60; // -60..60
  const lon = (((h >> 3) % 36000) / 100) - 180; // -180..180
  return { code: c, city: c, country: "", region: "Other", lat, lon, synthetic: true };
}

export function haversineMiles(a, b) {
  const R = 3958.8;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lon - a.lon);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return Math.round(R * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h)));
}

// Distance-based award bands [economy, premium, business, first] in points.
// Derived from published distance-based charts (Alaska/Aeroplan/Qantas style).
const AWARD_BANDS = [
  { max: 500, pts: [6000, 9000, 12500, 20000] },
  { max: 1000, pts: [7500, 11000, 15000, 25000] },
  { max: 2000, pts: [12500, 18000, 25000, 40000] },
  { max: 3000, pts: [20000, 27500, 35000, 57500] },
  { max: 4000, pts: [25000, 35000, 45000, 70000] },
  { max: 6000, pts: [35000, 47500, 60000, 90000] },
  { max: 8000, pts: [45000, 60000, 77500, 110000] },
  { max: 99999, pts: [55000, 72500, 90000, 130000] },
];

const CABIN_INDEX = { economy: 0, premium: 1, business: 2, first: 3 };

export function pointsFor(distance, cabin) {
  const band = AWARD_BANDS.find((b) => distance <= b.max);
  return band.pts[CABIN_INDEX[cabin]];
}

export function durationFor(distance) {
  const hours = distance / 500 + 0.6; // ~500mph + taxi/climb
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return `${h}h ${m}m`;
}

export function taxesFor(origin, dest, program) {
  const intl = origin.country !== dest.country;
  if (!intl) return { amount: 5.6, currency: "USD" };
  // Programs known for high fuel surcharges
  const highSurcharge = ["Executive Club", "Miles & More", "KrisFlyer", "Mileage Club"];
  const base = highSurcharge.includes(program) ? 180 : 45;
  const seed = strHash(origin.code + dest.code + program);
  const amount = Math.round((base + (seed % 120)) * 100) / 100;
  return { amount, currency: "USD" };
}

// ---------------------------------------------------------------------------
// Deterministic PRNG so results are stable per query
// ---------------------------------------------------------------------------
export function strHash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h);
}
function mulberry32(seed) {
  return function () {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function programsForRoute(rnd) {
  const a = Object.keys(AIRLINES);
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rnd() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Live-inventory drift: prices shift slightly every 6 hours (mirrored in backend/engine.py)
export function driftBucket() {
  return Math.floor(Date.now() / (6 * 3600 * 1000));
}
function driftFor(origin, destination, day) {
  const rnd = mulberry32(strHash(`${origin}${destination}${day}#${driftBucket()}`));
  return 0.9 + rnd() * 0.2;
}

function partnerLogos(program) {
  return PROGRAM_PARTNERS[program] || ["AMEX"];
}

export function fmtPoints(pts) {
  return pts >= 1000 ? `${(pts / 1000).toFixed(pts % 1000 === 0 ? 0 : 1)}k` : `${pts}`;
}

export function fmtDate(d) {
  return new Date(d).toLocaleDateString("en-US", {
    weekday: "short", month: "short", day: "numeric", year: "numeric",
  });
}

export function addDays(dateStr, n) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}

// ---------------------------------------------------------------------------
// SEARCH: availability for a specific route across a date window
// ---------------------------------------------------------------------------
export function searchAvailability({ origin, destination, date, flexDays = 3, cabins }) {
  const o = resolveAirport(origin);
  const d = resolveAirport(destination);
  if (!o || !d) return [];
  const distance = haversineMiles(o, d);
  const duration = durationFor(distance);
  const results = [];
  const wantCabins = cabins && cabins.length ? cabins : ["economy", "premium", "business", "first"];

  for (let offset = -flexDays; offset <= flexDays; offset++) {
    const day = addDays(date, offset);
    const rnd = mulberry32(strHash(origin + destination + day));
    const programs = programsForRoute(rnd);
    const drift = driftFor(origin, destination, day);
    const count = 2 + Math.floor(rnd() * 3);
    for (let i = 0; i < count; i++) {
      const code = programs[i % programs.length];
      const airline = AIRLINES[code];
      const cabin = wantCabins[Math.floor(rnd() * wantCabins.length)];
      const base = pointsFor(distance, cabin);
      const variance = 0.9 + rnd() * 0.35;
      const pts = Math.round((base * variance * drift) / 500) * 500;
      const taxes = taxesFor(o, d, airline.program);
      const seats = 1 + Math.floor(rnd() * 6);
      results.push({
        id: `${origin}${destination}${day}${code}${cabin}${i}`,
        date: day,
        airlineCode: code,
        airline: airline.name,
        program: airline.program,
        alliance: airline.alliance,
        origin: o, destination: d, distance, duration,
        cabin,
        points: pts,
        taxes,
        seats,
        partners: partnerLogos(airline.program),
        fresh: rnd() > 0.4,
        lastSeen: `${1 + Math.floor(rnd() * 40)}m ago`,
      });
    }
  }
  return results;
}

// ---------------------------------------------------------------------------
// EXPLORE: featured deals departing from a region
// ---------------------------------------------------------------------------
export function exploreDeals(region = "North America", cabin = "business", count = 24) {
  const origins = AIRPORTS.filter((a) => a.region === region);
  const dests = AIRPORTS;
  const deals = [];
  const rnd = mulberry32(strHash(region + cabin));
  let guard = 0;
  while (deals.length < count && guard < count * 6) {
    guard++;
    const o = origins[Math.floor(rnd() * origins.length)];
    const d = dests[Math.floor(rnd() * dests.length)];
    if (!o || !d || o.code === d.code) continue;
    const distance = haversineMiles(o, d);
    const codes = Object.keys(AIRLINES);
    const code = codes[Math.floor(rnd() * codes.length)];
    const airline = AIRLINES[code];
    const base = pointsFor(distance, cabin);
    const pts = Math.round((base * (0.85 + rnd() * 0.3)) / 500) * 500;
    const daysAhead = 20 + Math.floor(rnd() * 120);
    const date = addDays(new Date().toISOString().slice(0, 10), daysAhead);
    const taxes = taxesFor(o, d, airline.program);
    deals.push({
      id: `${region}${o.code}${d.code}${code}${guard}`,
      date, cabin,
      airlineCode: code, airline: airline.name, program: airline.program,
      origin: o, destination: d, distance, duration: durationFor(distance),
      points: pts, taxes, partners: partnerLogos(airline.program),
    });
  }
  return deals;
}

// ---------------------------------------------------------------------------
// AWARD CALENDAR: cheapest points per day for a route across a month
// ---------------------------------------------------------------------------
export function monthAwardCalendar(origin, destination, cabin, year, monthIndex) {
  const o = resolveAirport(origin);
  const d = resolveAirport(destination);
  if (!o || !d) return { days: [], min: 0, max: 0, distance: 0 };
  const distance = haversineMiles(o, d);
  const base = pointsFor(distance, cabin);
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const days = [];
  let min = Infinity;
  let max = 0;
  for (let day = 1; day <= daysInMonth; day++) {
    const dateObj = new Date(year, monthIndex, day);
    const dateStr = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    const past = dateObj < today;
    const rnd = mulberry32(strHash(origin + destination + cabin + dateStr));
    const available = !past && rnd() > 0.22; // ~78% of future days have space
    let points = null;
    let program = null;
    if (available) {
      // cheapest across a few candidate programs
      let best = Infinity;
      const codes = Object.keys(AIRLINES);
      const n = 2 + Math.floor(rnd() * 3);
      for (let i = 0; i < n; i++) {
        const code = codes[Math.floor(rnd() * codes.length)];
        const variance = 0.85 + rnd() * 0.4;
        const pts = Math.round((base * variance) / 500) * 500;
        if (pts < best) { best = pts; program = AIRLINES[code].program; }
      }
      points = best;
      if (points < min) min = points;
      if (points > max) max = points;
    }
    days.push({ date: dateStr, day, weekday: dateObj.getDay(), points, program, past, available });
  }
  if (min === Infinity) min = 0;
  return { days, min, max, distance, duration: durationFor(distance) };
}
// ---------------------------------------------------------------------------
// PRO paywall: free accounts see the next FREE_WINDOW_DAYS; PRO sees PRO_WINDOW_DAYS
// ---------------------------------------------------------------------------
export const fmtNumber = (n) => new Intl.NumberFormat().format(Math.round(n || 0));

export const FREE_WINDOW_DAYS = 30;
export const PRO_WINDOW_DAYS = 365;

export function daysFromToday(dateStr) {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const [y, m, d] = String(dateStr).slice(0, 10).split("-").map(Number);
  return Math.round((new Date(y, m - 1, d) - today) / 86400000);
}
export function isDateLocked(dateStr, isPro) {
  return !isPro && daysFromToday(dateStr) > FREE_WINDOW_DAYS;
}
export function freeWindowEnd() {
  return addDays(new Date().toISOString().slice(0, 10), FREE_WINDOW_DAYS);
}

// ---------------------------------------------------------------------------
// Booking links: send users to the airline's award site (deep-linked where supported)
// ---------------------------------------------------------------------------
const BOOKING = {
  AA: (o, d, dt) => `https://www.aa.com/booking/search?locale=en_US&pax=1&adult=1&type=OneWay&searchType=Award&cabin=&carriers=ALL&slices=%5B%7B%22orig%22:%22${o}%22,%22origNearby%22:false,%22dest%22:%22${d}%22,%22destNearby%22:false,%22date%22:%22${dt}%22%7D%5D`,
  AS: (o, d, dt) => `https://www.alaskaair.com/search/results?A=1&O=${o}&D=${d}&OD=${dt}&RT=false&ShoppingMethod=onlineaward`,
  DL: (o, d, dt) => `https://www.delta.com/flight-search/book-a-flight?tripType=ONE_WAY&fromCity=${o}&toCity=${d}&departureDate=${dt}&paxCount=1&searchByMiles=true`,
  UA: (o, d, dt) => `https://www.united.com/en/us/fsr/choose-flights?f=${o}&t=${d}&d=${dt}&tt=1&at=1&sc=7&px=1&taxng=1&newHP=True&clm=7&st=bestmatches&awardTravel=true`,
  AC: (o, d, dt) => `https://www.aircanada.com/aeroplan/redeem/availability/outbound?org0=${o}&dest0=${d}&departureDate0=${dt}&ADT=1&YTH=0&CHD=0&INF=0&INS=0&lang=en-CA&tripType=O&marketCode=INT`,
  BA: () => "https://www.britishairways.com/travel/redeem/execclub/_gf/en_gb",
  QF: () => "https://www.qantas.com/us/en/frequent-flyer/use-points/classic-flight-rewards.html",
  QR: () => "https://www.qatarairways.com/en/Privilege-Club/redeem-avios.html",
  EK: () => "https://www.emirates.com/us/english/skywards/spend-miles/",
  SQ: () => "https://www.singaporeair.com/en_UK/us/ppsclub-krisflyer/use-miles/",
  NH: () => "https://www.ana.co.jp/en/us/amc/reference/tukau/award/int/",
  LH: () => "https://www.miles-and-more.com/us/en/spend/flights.html",
  AF: (o, d, dt) => `https://wwws.airfrance.us/search/offers?pax=1:0:0:0:0:0:0:0&cabinClass=ECONOMY&activeConnection=0&connections=${o}:A>${d}:A-${dt}&bookingFlow=REWARD`,
  VS: () => "https://www.virginatlantic.com/flying-club/spend-points/flights",
  TK: () => "https://www.turkishairlines.com/en-int/miles-and-smiles/spend-miles/",
  EI: () => "https://www.aerlingus.com/aerclub/spend-avios/",
  SK: () => "https://www.flysas.com/en/eurobonus/use-points/",
  AV: () => "https://www.lifemiles.com/fly/find",
  LA: () => "https://www.latampass.latam.com/en_us/redeem-miles/flights",
};
export function bookingUrl(deal) {
  const fn = BOOKING[deal.airlineCode];
  return fn ? fn(deal.origin.code, deal.destination.code, deal.date) : `https://www.google.com/search?q=${encodeURIComponent(`${deal.program} award booking`)}`;
}
export function googleFlightsUrl(deal) {
  return `https://www.google.com/travel/flights?q=${encodeURIComponent(`Flights from ${deal.origin.code} to ${deal.destination.code} on ${deal.date} one way ${deal.cabin === "economy" ? "" : deal.cabin + " class"}`.trim())}`;
}

// ---------------------------------------------------------------------------
// CABIN COMPARE: cheapest option per cabin for one route + date, with cash value
// ---------------------------------------------------------------------------
const CASH_MULT = { economy: 1, premium: 1.8, business: 3.6, first: 5.8 };
export function estimateCashFare(distance, cabin) {
  return Math.round((80 + distance * 0.11) * (CASH_MULT[cabin] || 1));
}
export function centsPerPoint(cash, points, taxes) {
  if (!points) return null;
  return Math.round(((cash - taxes) / points) * 100 * 100) / 100;
}
export function compareCabins(origin, destination, date) {
  const o = resolveAirport(origin);
  const d = resolveAirport(destination);
  if (!o || !d) return null;
  const distance = haversineMiles(o, d);
  const cabins = CABINS.map((c) => {
    const options = searchAvailability({ origin, destination, date, flexDays: 0, cabins: [c.key] })
      .sort((a, b) => a.points - b.points);
    const best = options[0] || null;
    const cash = estimateCashFare(distance, c.key);
    const cpp = best ? centsPerPoint(cash, best.points, best.taxes.amount) : null;
    return { ...c, options, best, cash, cpp };
  });
  const withBest = cabins.filter((c) => c.best);
  const cheapest = withBest.length ? withBest.reduce((a, b) => (b.best.points < a.best.points ? b : a)).key : null;
  const bestValue = withBest.length ? withBest.reduce((a, b) => (b.cpp > a.cpp ? b : a)).key : null;
  return { origin: o, destination: d, distance, duration: durationFor(distance), cabins, cheapest, bestValue };
}

// ---------------------------------------------------------------------------
export const FEATURES = [
  { badge: "PRO", title: "Continuous Alerts", body: "No more repetitive searches. Create alerts to be notified when the best seats are released. Customize by operating airline, cost in points, and more.", cta: "Create an alert", to: "/alerts" },
  { badge: "Free", title: "Lightning Fast Search", body: "No more waiting. We're constantly checking flights with airlines in the background, so you see results immediately. Search weeks at a time or between regions.", cta: "Run a Search", to: "/search" },
  { badge: "Free", title: "Explore Awards", body: "No more guessing. Click on airport codes in our Explore tool to instantly see every award flight departing or arriving from any airport. Sort by cabin.", cta: "Explore", to: "/explore" },
  { badge: "PRO", title: "Live Search", body: "Pro users can search for any route in our Search tool with our live search feature for real-time, up-to-the-minute availability.", cta: "Learn more", to: "/pricing" },
  { badge: "New", title: "AI Assistant", body: "Our AI assistant helps you plan your next trip, find sweet spots, set alerts, and answer any points-and-miles question you have.", cta: "Try it out", to: "/chat" },
  { badge: "PRO", title: "Multi-city codes", body: "Search between many airports at once with metro codes. Explore availability across an entire city or region in a single search.", cta: "Learn more", to: "/search" },
];

// ---------------------------------------------------------------------------
// Phase 3 — SEO comparison funnel data
// ---------------------------------------------------------------------------
export const COMPARISONS = SEO_CONTENT.comparisons;

// This app's own row for comparison tables
export const THIS_APP = SEO_CONTENT.thisApp;

// Q&A content for the home page (also served to AI crawlers via /api/prerender and llms.txt)
export const HOME_FAQ = SEO_CONTENT.homeFaq;
